<template>
  <div ref="tag" :style="tagPosition" class="tag-container" @click.stop>
    <em
      class="top"
      :style="arrowPosition"
      :class="{ hide: !tagArrowTop, product, people }"
    ></em>
    <div
      ref="bubble"
      class="tag-main-container"
      :class="{ readonly, product, people }"
    >
      <template v-if="type === 'people'">
        {{ model.username }}
        <div v-if="!readonly" class="del-icon" @click.stop="remove()"></div>
      </template>
      <template v-if="type === 'product'">
        <div class="left-container">
          <div class="product-name">{{ model.name }}</div>
          <div class="price-container">
            <div class="product-price">{{ model.current_price }}</div>
            <div class="full-price">{{ model.full_price }}</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="right-container">
          <div class="right-icon"></div>
          <div v-if="!readonly" @click.stop="remove()" class="close-icon">
            <div class="icon"></div>
          </div>
        </div>
      </template>
    </div>
    <em
      class="bottom"
      :style="arrowPosition"
      :class="{ hide: tagArrowTop, product, people }"
    ></em>
  </div>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.tag-container {
  @tagColor: rgba(0, 0, 0, 0.6);
  position: absolute;
  float: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  .tag-main-container {
    cursor: move;
    &.readonly {
      cursor: inherit;
      padding: 0 10px;
    }

    &.product {
      padding: 6px 0;
      background: white;
      border-radius: 4px;
      display: flex;
      position: relative;
      align-items: center;
      .left-container {
        padding-left: 6px;
        .product-name {
          width: 110px;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          text-align: left;
          -webkit-box-orient: vertical;
          font-weight: 500;
        }
        .price-container {
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-top: 2px;
          .product-price {
            color: #ec2052;
          }
          .full-price {
            color: rgb(90, 90, 90);
            margin-left: 5px;
            text-decoration: line-through;
          }
        }
      }
      .line {
        width: 1px;
        background: #e6e6e6;
        margin-left: 7px;
      }
      .close-icon {
        cursor: pointer;
        position: absolute;
        right: -5px;
        top: -4px;
        border-radius: 50%;
        background: rgb(90, 90, 90);
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon {
          background-size: contain;
          width: 14px;
          height: 14px;
          background-image: url("../../../../public/images/common/Close_w@3x.png");
        }
        &:hover,
        &:active {
          opacity: 0.7;
        }
      }
      .right-icon {
        width: 8px;
        height: 14px;
        background-image: url("../../../../public/images/schedule_posts/Date_Right@3x.png");
        background-size: contain;
        margin: 0 7px;
      }
    }

    &.people {
      border-radius: 4px;
      color: white;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      padding: 0 30px 0 10px;
      background: @tagColor;
      cursor: move;
      user-select: none;
      position: relative;
      white-space: nowrap;

      .del-icon {
        position: absolute;
        right: 10px;
        top: 9px;
        width: 12px;
        height: 12px;
        background-image: url("../../../../public/images/schedule_posts/tag_people/tagpeople_close@3x.png");
        background-size: contain;
        cursor: pointer;
      }
    }
  }

  em {
    display: block;
    border-width: 4px;
    border-style: solid dashed dashed;
    position: absolute;
    font-size: 0;
    line-height: 0;
    border-color: transparent;
    &.people {
      &.bottom {
        border-top-color: @tagColor;
      }
      &.top {
        border-bottom-color: @tagColor;
      }
    }
    &.product {
      &.bottom {
        border-top-color: white;
      }
      &.top {
        border-bottom-color: white;
      }
    }
    &.bottom {
      bottom: -8px;
    }

    &.top {
      top: -8px;
    }
    &.hide {
      border-color: transparent !important;
    }
  }
}
</style>

<script>
import { imageLoad } from "../../../utils/media";

export default {
  name: "TagItemComponent",
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "people",
    },
  },
  model: {
    prop: "model",
    event: "updateModel",
  },
  watch: {
    position(val) {
      this.$emit("updateModel", val);
    },
  },
  computed: {
    product() {
      return this.type === "product";
    },
    people() {
      return this.type === "people";
    },
    /**
     * 计算tag 容器所在位置
     */
    tagPosition() {
      if (this.count) {
      }
      if (this.tagEl && this.mounted) {
        // 整个气泡宽 高
        const bubbleWidth = this.tagEl.clientWidth;
        const bubbleHeight = this.tagEl.clientHeight + this.arrowSize;
        const groupWidth = this.$parent.$refs.group.clientWidth;
        let left = this.position.x - bubbleWidth / 2 + this.arrowSize;
        let top = this.position.y + this.arrowSize;

        // 计算箭头朝下情况
        if (!this.tagArrowTop) {
          top = this.position.y - bubbleHeight;
        }
        // 左右超出范围
        if (this.overLeftDistance) {
          // 判断已经超出
          if (this.overLeftDistance.isLeft) {
            left = 0;
          } else {
            left = groupWidth - bubbleWidth;
          }
        } else {
          // 正常情况
          left = this.position.x - bubbleWidth / 2;
        }
        return {
          left: `${left}px`,
          top: `${top}px`,
        };
      }
    },
    /**
     * 计算箭头偏移
     */
    arrowPosition() {
      if (this.count) {
      }
      if (this.overLeftDistance === undefined) {
        return {};
      }
      return {
        left: `${this.overLeftDistance.x}px`,
      };
    },
    /**
     * 判断是否超出需要箭头移动
     */
    overLeftDistance() {
      if (this.count) {
      }
      if (this.tagEl && this.mounted) {
        const bubbleWidth = this.tagEl.clientWidth;
        const groupWidth = this.$parent.$refs.group.clientWidth;
        // 此时气泡已经超出左侧极限只能滚动箭头
        if (this.position.x < bubbleWidth / 2) {
          return { x: this.position.x - this.arrowSize, isLeft: true };
        } else if (groupWidth - this.position.x < bubbleWidth / 2) {
          // 右侧超出
          return {
            x: this.position.x + bubbleWidth - groupWidth - this.arrowSize,
            isLeft: false,
          };
        }
      }
    },
    /**
     * 计算箭头是否朝上
     */
    tagArrowTop() {
      if (this.count) {
      }
      if (this.tagEl && this.mounted) {
        const bubbleHeight = this.tagEl.clientHeight + this.arrowSize;
        // 获取父容器
        const groupHeight = this.$parent.$refs.group.clientHeight;
        // 判断气泡箭头朝下是否可以指向坐标
        return groupHeight - this.MAX_TOP - this.position.y > bubbleHeight;
      }
    },
  },
  data() {
    return {
      position: {
        x: 0,
        y: 0,
        position: [0, 0],
        user_id: "",
        username: "",
      },
      count: false,
      tagEl: null,
      MAX_LEFT: 10,
      MAX_TOP: 10,
      arrowSize: 4,
      mounted: false,
    };
  },
  methods: {
    /**
     * 删除按钮点击回调
     */
    remove() {
      this.$emit("remove");
    },
    /**
     * 初始化tag拖拽
     * 1.首先添加tag元素拖拽监听
     * 2.验证边界是否超出范围
     * 2.1左右边界箭头自动平移
     * 2.2上下边界箭头自动切换方向
     */
    initTag() {
      const groupWidth = this.$parent.$refs.group.clientWidth;
      const groupHeight = this.$parent.$refs.group.clientHeight;
      // 获取tag元素
      this.tagEl = this.$refs.tag;
      this.tagEl.onmousedown = (e) => {
        if (this.readonly) return;
        this.count = !this.count;
        this.$parent.showSearch = false;
        const startX = e.pageX;
        const startY = e.pageY;
        const imageX = this.position.x;
        const imageY = this.position.y;
        // 防止鼠标图标变化1
        e.preventDefault();
        document.onmousemove = (e) => {
          this.count = !this.count;
          // 计算移动后坐标
          let containerX = imageX + e.pageX - startX;
          let containerY = imageY + e.pageY - startY;
          // 判断位移不能超出范围
          if (containerX < this.MAX_LEFT) {
            // 左侧极限
            this.position.x = this.MAX_LEFT;
          } else if (groupWidth - this.MAX_LEFT < containerX) {
            // 右侧极限
            this.position.x = groupWidth - this.MAX_LEFT;
          } else {
            this.position.x = containerX;
          }
          if (containerY < this.MAX_TOP) {
            // 上方极限
            this.position.y = this.MAX_TOP;
          } else if (groupHeight - this.MAX_TOP < containerY) {
            // 下方极限
            this.position.y = groupHeight - this.MAX_TOP;
          } else {
            this.position.y = containerY;
          }
        };
        document.onmouseup = () => {
          this.count = !this.count;
          // 松手之时重新计算位置，
          const { clientWidth, clientHeight } = this.$parent.$refs.group;
          this.position.position[0] = this.position.x / clientWidth;
          this.position.position[1] = this.position.y / clientHeight;
          this.$parent.showSearch = false;
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
    },
  },
  mounted() {
    this.mounted = false;
    this.$nextTick(async () => {
      this.mounted = true;
      const { clientWidth, clientHeight } = this.$parent.$refs.group;
      this.position = this.model;
      // 初始化位置信息
      this.position.x = clientWidth * this.model.position[0];
      this.position.y = clientHeight * this.model.position[1];
      this.initTag();
      if (this.readonly) {
        const url = this.$parent.image.coverUrl;
        // 获取图片宽高比
        const image = new Image();
        image.src = url;
        await imageLoad({ image });
        const { width, height } = image;
        this.position.y =
          (height / width) * clientWidth * this.model.position[1];
      }
      this.count = !this.count;
    });
  },
};
</script>
